import { IdNameList } from "../../../api/services/common/models";
import { AddressAndContactDetails } from "../../../api/services/mdmOffice/models";
import { StatusBadgeType } from "../../../components/statusBadge/StatusBadge";
import { LabelValue } from "../../../helpers/types/common";
import { searchMdmActivitySiteCoreKeys } from "../../mdmActivitySearch/siteCore/SiteCoreKeys";

export interface ModalityType {
  modalityId: string;
  modalityName: string;
}

export interface MdmOfficeSearchResultFiltersTypes {
  parentOffice: LabelValue[];
  officeCode: LabelValue[];
  statusId: LabelValue[];
  city: LabelValue[];
  state: LabelValue[];
  marketValue: LabelValue[];
  countryId: LabelValue[];
}

export interface MdmSearchOfficeResultFilterForm {
  officeName: string;
  parentOffice: string;
  officeCode: string;
  statusId: string;
  officeType: string;
  city: string;
  state: string;
  market: string;
  marketValue: string;
  countryId: string;
}

export const MdmSearchOfficeResultFilterFormKey = {
  officeName: "officeName",
  parentOffice: "parentOffice",
  officeCode: "officeCode",
  statusId: "statusId",
  officeType: "officeType",
  city: "city",
  state: "state",
  market: "market",
  marketValue: "marketValue",
  countryId: "countryId",
} as const;

export interface MdmSearchOfficeResultRowValue {
  id: string;
  officeName: string;
  parentOffice: string;
  officeCode: string;
  statusId: string;
  officeType: string;
  city: string;
  state: string;
  market: IdNameList;
  marketValue: string;
  countryId: string;
  [key: string]: any;
}

export const MdmSearchOfficeResultRowKey = {
  officeName: "officeName",
  parentOffice: "parentOffice",
  officeCode: "officeCode",
  statusId: "statusId",
  officeType: "officeType",
  city: "city",
  state: "state",
  marketValue: "marketValue",
  countryId: "countryId",
  market: "market",
  id: "id",
  status: "status",
} as const;

export interface OfficeSearchFormType {
  officeName: string;
  parentOffice: string;
  officeType?: string;
  marketId: string;
  state: string;
  city: string;
  status: string;
  officeNameFilter: string;
  parentOfficeFilter: string;
  cityFilter: string;
  stateFilter: string;
  countryId: string;
}

export const OfficeSearchFormKey = {
  officeName: "officeName",
  parentOffice: "parentOffice",
  officeType: "officeType",
  marketId: "marketId",
  state: "state",
  city: "city",
  status: "status",
  officeNameFilter: "officeNameFilter",
  parentOfficeFilter: "parentOfficeFilter",
  cityFilter: "cityFilter",
  stateFilter: "stateFilter",
  countryId: "countryId",
} as const;

export const OfficeSearchFormDefaultValues = {
  [OfficeSearchFormKey.officeName]: "",
  [OfficeSearchFormKey.parentOffice]: "",
  [OfficeSearchFormKey.officeType]: "",
  [OfficeSearchFormKey.officeNameFilter]:
    searchMdmActivitySiteCoreKeys.contains,
  [OfficeSearchFormKey.marketId]: "",
  [OfficeSearchFormKey.state]: "",
  [OfficeSearchFormKey.city]: "",
  [OfficeSearchFormKey.status]: "",
  [OfficeSearchFormKey.parentOfficeFilter]:
    searchMdmActivitySiteCoreKeys.contains,
  [OfficeSearchFormKey.cityFilter]: searchMdmActivitySiteCoreKeys.contains,
  [OfficeSearchFormKey.stateFilter]: searchMdmActivitySiteCoreKeys.contains,
};

export interface ViewOfficeDetailsType {
  officeName: string;
  parentOffice: IdNameList;
  officeCode: string;
  officeType: string;
  market: IdNameList;
  region: IdNameList;
  billingOffice: IdNameList;
  salesCreditOffice: IdNameList;
  currency: IdNameList;
  invoiceTemplate: IdNameList;
  salesCreditTemplate: IdNameList;
  taxes: IdNameList[];
  statusId: StatusBadgeType;
  isSalesCreditOffice?: boolean;
  isBillingOffice?: boolean;
}

export interface OfficeDetailsResponse {
  id?: string;
  officeDetails: ViewOfficeDetailsType;
  addressAndContactDetails: AddressAndContactDetails;
  invoicingDetails: InvoicingDetails;
}

export interface InvoicingDetails {
  header: string;
  footer1: string;
  footer2: string;
  footer3: string;
}
